webpackJsonp([49],{

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetailDescription__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetailDescription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DetailDescription__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		DetailDescription: __WEBPACK_IMPORTED_MODULE_0__DetailDescription___default.a
	},
	name: 'list-detail-description',
	props: {
		details: {
			type: Array,
			required: true
		}
	}
});

/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1110),
  /* template */
  __webpack_require__(1181),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1181:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, _vm._l((_vm.details), function(detail) {
    return _c('detail-description', {
      key: detail.label,
      attrs: {
        "icon": detail.icon,
        "label": detail.label,
        "description": detail.description
      }
    })
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_ListDetailDescription__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_ListDetailDescription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_ListDetailDescription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_UserSelector__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_UserSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_UserSelector__);





var changeTypeCleaning = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(item) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('setting/' + item.type_clean + '/' + item.hot_ms_roomtype_id + '/time');

					case 2:
						response = _context.sent;

						this.rows = this.rows.map(function (row) {
							var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row);
							if (item.id === row.id) {
								if (response.data.time) {
									newRow.time_standard = response.data.time;
								} else {
									newRow.time_standard = 1;
								}
							}
							return newRow;
						});

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function changeTypeCleaning(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _this2 = this;

		var response, request, typeCleaningResponse, responses;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						response = helperMethods.getHousemaidAssign();
						request = [];

						response.selectedHousemaid.room_assigned = response.rooms.length;
						response.selectedHousemaid.isOnlyRead = true;
						this.details = [{
							description: response.filterDate,
							icon: 'date',
							label: 'Fecha de creación'
						}, {
							description: new Date().toLocaleTimeString(),
							icon: 'time-done',
							label: 'Hora asignada'
						}, {
							description: response.currentSupervisor.name + ' ' + response.currentSupervisor.lastname,
							icon: 'supervisor',
							label: 'Supervisora'
						}];
						this.housemaid = response.selectedHousemaid;
						this.supervisor = response.currentSupervisor;
						this.date = response.filterDate;
						_context2.next = 10;
						return this.$http.get('setting-simple-list');

					case 10:
						typeCleaningResponse = _context2.sent;

						this.items = typeCleaningResponse.data;
						response.rooms.forEach(function (room) {
							request.push(_this2.$http.get('setting/' + typeCleaningResponse.data[0].id + '/' + room.hot_ms_roomtype_id + '/time'));
						});
						_context2.next = 15;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(request);

					case 15:
						responses = _context2.sent;

						this.rows = response.rooms.map(function (room, roomIndex) {
							var newRoom = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, room);
							typeCleaningResponse.data.forEach(function (typeClean, typeCleanIndex) {
								if (typeCleanIndex === 0) {
									if (responses[roomIndex].data.time) {
										newRoom.time_standard = responses[roomIndex].data.time;
									} else {
										newRoom.time_standard = 1;
									}
								}
							});
							newRoom.type_clean = typeCleaningResponse.data[0].id;
							return newRoom;
						});

					case 17:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadData() {
		return _ref3.apply(this, arguments);
	};
}();

var assignHousemaid = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _this3 = this;

		var assignUrl, promises;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						assignUrl = 'housekeeping';
						promises = this.rows.map(function (row, rowIndex) {
							var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, row);
							newRow.order = rowIndex + 1;
							var model = {
								com_companies_id: helperMethods.getUser().company_id,
								com_employee_id: _this3.housemaid.id,
								com_subsidiaries_id: row.com_subsidiary_id,
								hot_room_id: row.id,
								com_ms_type_cleaning_id: row.type_clean,
								supervisor_id: _this3.supervisor.id,
								hot_ms_statehk_id: 1,
								date_clear: _this3.date,
								duration_time_clear: null,
								duration_time_break: null,
								duration_time_bat: null,
								duration_standard: row.time_standard,
								observation: {
									detail: null
								},
								order: newRow.order,
								tasks: null
							};
							return _this3.$http.post(assignUrl, model);
						});
						_context3.next = 4;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);

					case 4:
						this.showNotification('Se asignaron correctamente las habitaciones', 'success');
						this.$router.push({ name: 'housemaids-list' });

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function assignHousemaid() {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var helperMethods = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].methods;

function beforeRouteEnter(from, to, next) {
	if (__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].methods.getHousemaidAssign()) {
		return next();
	}
	return next({ name: 'housemaids-list' });
}

function columnSortableEvent(_ref2) {
	var _this = this;

	var id = _ref2.id;

	setTimeout(function () {
		var newData = [];
		var newColumn = _this.columns.filter(function (column) {
			return column.id === id;
		});
		newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
		var columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = _this.rows.sort(function (a, b) {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = _this.rows.sort(function (a, b) {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		_this.rows = newData;
	}, 300);
}

function created() {
	this.loadData();
}

function deleteRow(id) {
	var index = this.rows.findIndex(function (row) {
		return row.id === id;
	});
	if (index >= 0) {
		this.rows.splice(index, 1);
	}
}

function destroyed() {
	helperMethods.removeHousemaidAssign();
}

function setRowSelected(item) {
	var index = this.rows.findIndex(function (row) {
		return row.id === item.id;
	});
	this.rowIsDraggable = item;
	this.indexRow = index;
}

function sortableRows(item) {
	var index = this.rows.findIndex(function (row) {
		return row.id === item.id;
	});
	this.rows.splice(index, 0, this.rows.splice(this.indexRow, 1)[0]);
}

function toInt(value) {
	var newValue = value.toString();
	if (!value) {
		this.showNotification('El valor para tiempo estándar debe ser un número válido', 'error');
		this.isDisabled = true;
	} else if (value <= 0) {
		this.showNotification('El mínimo valor requerido es 1', 'error');
		this.isDisabled = true;
	} else if (newValue && newValue !== '' && newValue.indexOf('.') > -1) {
		this.showNotification('El valor para tiempo estándar debe ser un número entero', 'error');
		this.isDisabled = true;
	} else {
		this.isDisabled = false;
	}
}

/* harmony default export */ __webpack_exports__["default"] = ({
	beforeRouteEnter: beforeRouteEnter,
	components: {
		ListDetailDescription: __WEBPACK_IMPORTED_MODULE_7__components_shared_ListDetailDescription___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_4_table_run___default.a,
		UserSelector: __WEBPACK_IMPORTED_MODULE_8__components_shared_UserSelector___default.a
	},
	created: created,
	data: function data() {
		return {
			columns: [{ id: 1, name: '# Habitación', code: 'number', isSortable: { down: true, up: false } }, { id: 2, name: 'Tipo', code: 'hot_ms_roomtype_id', isSortable: { down: true, up: false } }, { id: 3, name: 'Estado', code: 'state', isSortable: { down: true, up: false } }, { id: 4, name: 'Piso', code: 'hot_floor_id', isSortable: { down: true, up: false } }, { id: 5, name: 'Tipo de limpieza', code: 'type_clean', isSortable: { down: true, up: false } }, { id: 6, name: 'Tiempo estándar', code: 'standard_time', isSortable: { down: true, up: false } }],
			date: null,
			helperMethods: null,
			housemaid: null,
			indexRow: null,
			items: [],
			rows: [],
			rowIsDraggable: null,
			supervisor: null,
			details: null,
			isDisabled: false
		};
	},

	destroyed: destroyed,
	methods: {
		assignHousemaid: assignHousemaid,
		changeTypeCleaning: changeTypeCleaning,
		columnSortableEvent: columnSortableEvent,
		deleteRow: deleteRow,
		loadData: loadData,
		setRowSelected: setRowSelected,
		sortableRows: sortableRows,
		toInt: toInt
	},
	mixins: __WEBPACK_IMPORTED_MODULE_6__shared_mixins__["a" /* default */],
	name: 'housemaids-assign'
});

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".assign-box[data-v-07473fb2]{background-color:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);margin:auto!important;max-width:90%}.options-column[data-v-07473fb2]{display:none}.options-column.options-column-housemaids[data-v-07473fb2]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-ms-flex-pack:distribute;justify-content:space-around}.options-column.options-column-housemaids span[data-v-07473fb2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.options-column.options-column-housemaids .arrow-move[data-v-07473fb2]{cursor:pointer;height:15px;margin-right:10px}.options-column.options-column-housemaids img[data-v-07473fb2]{height:15px}.delete-item[data-v-07473fb2]{background-color:#ee3737;border-radius:50%;color:#fff;cursor:pointer;height:15px;line-height:1;text-align:center;width:15px}.delete-icon[data-v-07473fb2]{color:#fff!important;font-size:13px!important;font-weight:700;height:auto!important;padding-left:.5px;padding-top:1px}.square-state[data-v-07473fb2]{border-radius:2px;display:inline-block;height:8px;margin-right:4px;vertical-align:middle;width:9px}.square-state+span[data-v-07473fb2]{vertical-align:middle}", "", {"version":3,"sources":["/opt/build/repo/src/housekeeping/housemaids/Assign.vue"],"names":[],"mappings":"AACA,6BACE,sBAAwB,AACxB,+CAAwD,AAChD,uCAAgD,AACxD,sBAAwB,AACxB,aAAe,CAChB,AACD,iCACE,YAAc,CACf,AACD,2DACI,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,yBAA0B,AACtB,4BAA8B,CACrC,AACD,gEACM,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CAC1B,AACD,uEACM,eAAgB,AAChB,YAAa,AACb,iBAAmB,CACxB,AACD,+DACM,WAAa,CAClB,AACD,8BACE,yBAA0B,AAC1B,kBAAmB,AACnB,WAAa,AACb,eAAgB,AAChB,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,UAAY,CACb,AACD,8BACE,qBAAwB,AACxB,yBAA2B,AAC3B,gBAAkB,AAClB,sBAAwB,AACxB,kBAAmB,AACnB,eAAiB,CAClB,AACD,+BACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,iBAAkB,AAClB,sBAAuB,AACvB,SAAW,CACZ,AACD,oCACI,qBAAuB,CAC1B","file":"Assign.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.assign-box[data-v-07473fb2] {\n  background-color: white;\n  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);\n          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);\n  margin: auto !important;\n  max-width: 90%;\n}\n.options-column[data-v-07473fb2] {\n  display: none;\n}\n.options-column.options-column-housemaids[data-v-07473fb2] {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n}\n.options-column.options-column-housemaids span[data-v-07473fb2] {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n}\n.options-column.options-column-housemaids .arrow-move[data-v-07473fb2] {\n      cursor: pointer;\n      height: 15px;\n      margin-right: 10px;\n}\n.options-column.options-column-housemaids img[data-v-07473fb2] {\n      height: 15px;\n}\n.delete-item[data-v-07473fb2] {\n  background-color: #ee3737;\n  border-radius: 50%;\n  color: white;\n  cursor: pointer;\n  height: 15px;\n  line-height: 1;\n  text-align: center;\n  width: 15px;\n}\n.delete-icon[data-v-07473fb2] {\n  color: white !important;\n  font-size: 13px !important;\n  font-weight: bold;\n  height: auto !important;\n  padding-left: .5px;\n  padding-top: 1px;\n}\n.square-state[data-v-07473fb2] {\n  border-radius: 2px;\n  display: inline-block;\n  height: 8px;\n  margin-right: 4px;\n  vertical-align: middle;\n  width: 9px;\n}\n.square-state + span[data-v-07473fb2] {\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1370);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("d4892d74", content, true);

/***/ }),

/***/ 1578:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "assign-box",
    attrs: {
      "row": "",
      "wrap": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "label-medium"
  }, [_vm._v("Mucamas asignadas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": "",
      "body-border-bottom": ""
    }
  }, [_c('user-selector', {
    key: _vm.housemaid.id,
    attrs: {
      "user": _vm.housemaid
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": "",
      "pt-2": ""
    }
  }, [_c('p', {
    staticClass: "label-medium mb-0"
  }, [_vm._v("Datos")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": "",
      "pt-2": ""
    }
  }, [_c('list-detail-description', {
    staticClass: "px-2",
    attrs: {
      "details": _vm.details
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "pt-2": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table no-search-table table-custom-options table-housemaid-assign",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": false,
      "include-options": true,
      "include-export-to-excel": false,
      "selectable": false
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-drag-event": _vm.setRowSelected,
      "on-drop-event": _vm.sortableRows
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.roomtype_name))]), _vm._v(" "), _c('td', [_c('span', {
          staticClass: "square-state",
          style: (("background-color: " + (props.row.color_state)))
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.room_state_name))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.hot_floor_id))]), _vm._v(" "), _c('td', [_c('v-select', {
          staticClass: "select-housemaid-assign",
          attrs: {
            "items": _vm.items,
            "item-text": "name",
            "item-value": "id",
            "hide-details": "",
            "single-line": "",
            "bottom": ""
          },
          on: {
            "input": function($event) {
              _vm.changeTypeCleaning(props.row)
            }
          },
          model: {
            value: (props.row.type_clean),
            callback: function($$v) {
              props.row.type_clean = $$v
            },
            expression: "props.row.type_clean"
          }
        })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
          staticClass: "time-standard-input",
          attrs: {
            "type": "number",
            "suffix": "min",
            "min": "1",
            "step": "1",
            "hide-details": ""
          },
          on: {
            "keyup": function($event) {
              _vm.toInt(props.row.time_standard)
            }
          },
          model: {
            value: (props.row.time_standard),
            callback: function($$v) {
              props.row.time_standard = _vm._n($$v)
            },
            expression: "props.row.time_standard"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right pr-2 options-column options-column-housemaids",
          class: {
            'active': props.row.classActive
          }
        }, [_c('div', {
          staticClass: "arrow-move"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/move.svg",
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "delete-item"
        }, [_c('v-icon', {
          staticClass: "delete-icon",
          on: {
            "click": function($event) {
              _vm.deleteRow(props.row.id)
            }
          }
        }, [_vm._v("close")])], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "pt-2": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-assign-tasks",
    attrs: {
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.assignHousemaid
    }
  }, [_vm._v("\n\t\t\tEnviar\n\t\t")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1455)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1347),
  /* template */
  __webpack_require__(1578),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-07473fb2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 927:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'detail-description',
	props: {
		icon: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: true
		},
		description: {
			type: [Date, String, Number],
			required: true
		}
	}
});

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".container-icon-description[data-v-3133e480]{border-radius:100%;display:inline-block;font-size:inherit;height:17px;letter-spacing:inherit;line-height:inherit;padding-top:0;text-align:center;width:17px}.container-icon-description.type-clean[data-v-3133e480]{background-color:#f6a623}.container-icon-description.date[data-v-3133e480]{background-color:#f6232a}.container-icon-description.time-standard[data-v-3133e480]{background-color:#25d90a}.container-icon-description.time-done[data-v-3133e480]{background-color:#0aceff}.container-icon-description.supervisor[data-v-3133e480]{background-color:#0f64e2}.key-description[data-v-3133e480]{color:#818181;margin:0 2px 0 5px}.key-description[data-v-3133e480],.value-description[data-v-3133e480]{font-family:San Francisco Display;font-size:14px;line-height:inherit;padding-top:0}.value-description[data-v-3133e480]{color:#353c4c;text-transform:capitalize}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/DetailDescription.vue"],"names":[],"mappings":"AACA,6CACE,mBAAoB,AACpB,qBAAsB,AACtB,kBAAmB,AACnB,YAAa,AACb,uBAAwB,AACxB,oBAAqB,AACrB,cAAiB,AACjB,kBAAmB,AACnB,UAAY,CACb,AACD,wDACI,wBAA0B,CAC7B,AACD,kDACI,wBAA0B,CAC7B,AACD,2DACI,wBAA0B,CAC7B,AACD,uDACI,wBAA0B,CAC7B,AACD,wDACI,wBAA0B,CAC7B,AACD,kCACE,cAAe,AAIf,kBAAwB,CAEzB,AACD,sEANE,kCAAqC,AACrC,eAAgB,AAChB,oBAAqB,AAErB,aAAiB,CASlB,AAPD,oCACE,cAAe,AAKf,yBAA2B,CAC5B","file":"DetailDescription.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.container-icon-description[data-v-3133e480] {\n  border-radius: 100%;\n  display: inline-block;\n  font-size: inherit;\n  height: 17px;\n  letter-spacing: inherit;\n  line-height: inherit;\n  padding-top: 0px;\n  text-align: center;\n  width: 17px;\n}\n.container-icon-description.type-clean[data-v-3133e480] {\n    background-color: #f6a623;\n}\n.container-icon-description.date[data-v-3133e480] {\n    background-color: #f6232a;\n}\n.container-icon-description.time-standard[data-v-3133e480] {\n    background-color: #25d90a;\n}\n.container-icon-description.time-done[data-v-3133e480] {\n    background-color: #0aceff;\n}\n.container-icon-description.supervisor[data-v-3133e480] {\n    background-color: #0f64e2;\n}\n.key-description[data-v-3133e480] {\n  color: #818181;\n  font-family: \"San Francisco Display\";\n  font-size: 14px;\n  line-height: inherit;\n  margin: 0px 2px 0px 5px;\n  padding-top: 0px;\n}\n.value-description[data-v-3133e480] {\n  color: #353c4c;\n  font-family: \"San Francisco Display\";\n  font-size: 14px;\n  line-height: inherit;\n  padding-top: 0px;\n  text-transform: capitalize;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(933);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("03f6ff8c", content, true);

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(936)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(942),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3133e480",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 942:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-inline-flex align-items-center"
  }, [(_vm.icon) ? _c('span', {
    class: ("container-icon-description " + _vm.icon)
  }, [_c('span', {
    class: ("sprite-icons " + _vm.icon)
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "key-description"
  }, [_vm._v(_vm._s(_vm.label) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "value-description"
  }, [_vm._v(_vm._s(_vm.description))])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/49.322a956f51ce7fbf9832.js